var map = {
	"./GNAM-logo.jpg": "./src/images/GNAM-logo.jpg",
	"./ajax-loader.gif": "./src/images/ajax-loader.gif",
	"./apple-touch-icon-114x114-precomposed.png": "./src/images/apple-touch-icon-114x114-precomposed.png",
	"./apple-touch-icon-144x144-precomposed.png": "./src/images/apple-touch-icon-144x144-precomposed.png",
	"./apple-touch-icon-72x72-precomposed.png": "./src/images/apple-touch-icon-72x72-precomposed.png",
	"./apple-touch-icon-precomposed.png": "./src/images/apple-touch-icon-precomposed.png",
	"./back_top_05A_arial_80.svg": "./src/images/back_top_05A_arial_80.svg",
	"./bx_loader.gif": "./src/images/bx_loader.gif",
	"./controls.png": "./src/images/controls.png",
	"./screenshot.png": "./src/images/screenshot.png",
	"./stripe.png": "./src/images/stripe.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive \\.(gif|png|jpe?g|svg)$";